<div [formGroup]="form">
  <label>
    <div class="app-checkbox">
      <input type="checkbox" [formControl]="checkbox">
      <span class="inner"></span>
    </div>
    <div class="message" trans="register.skip.interaction"></div>
  </label>
</div>
